// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const AccountIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M10.95 1.5c3.03 0 5.49 2.46 5.49 5.49s-2.46 5.49-5.5 5.49c-3.03 0-5.48-2.46-5.48-5.5 0-3.02 2.45-5.48 5.49-5.48m9.9 17.42-.12-.12v-1.07l.12-.12c.6-.36.71-1.08.36-1.67-.36-.6-1.08-.72-1.67-.36h-.12c-.24-.24-.48-.36-.84-.48v-.12c0-.71-.47-1.2-1.2-1.2-.7 0-1.18.49-1.18 1.2-.36.12-.72.24-.96.48-.6-.36-1.31-.12-1.67.36-.36.6-.12 1.31.36 1.67h.12c-.12.36-.12.83 0 1.2h-.12c-.6.35-.72 1.07-.36 1.66.36.6 1.07.72 1.67.36.36.24.6.48.96.6 0 .71.47 1.19 1.19 1.19s1.2-.48 1.2-1.2v-.11c.23-.12.59-.24.83-.48h.12c.6.36 1.3.24 1.67-.36.35-.36.24-1.2-.36-1.43m-3.46.36c-.6 0-1.08-.48-1.08-1.08s.48-1.07 1.08-1.07 1.07.48 1.07 1.07-.47 1.08-1.07 1.08" />
      <path
        d="M9.75 14.86c-1.67 0-3.22.24-4.41.6-.72.24-1.44.6-1.91 1.08-.48.47-.84 1.19-.84 2.02s.24 1.44.84 2.03c.47.48 1.19.84 1.9 1.08 1.2.35 2.75.6 4.42.6.72 0 1.2-.48 1.2-1.2v-5.01c0-.72-.48-1.2-1.2-1.2"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default AccountIcon;
